import { RefObject, useEffect } from 'react';

type OnOuterClickT = (e: Event) => void;

type InnerRefT = RefObject<HTMLElement>;
type TargetT = EventTarget | null;

export const isContainTarget = (ref: InnerRefT, target: TargetT) =>
  target instanceof Element && ref.current && ref.current.contains(target);

export default function useOuterClick(
  onOuterClick: OnOuterClickT,
  innerRef: RefObject<HTMLElement>,
  ignoredRefs?: Array<RefObject<HTMLElement>> | null
) {
  useEffect(() => {
    if (typeof document === undefined) {
      return;
    }

    if (innerRef.current) {
      document.addEventListener('pointerdown', handleClick);
    }

    return () => document.removeEventListener('pointerdown', handleClick);

    function handleClick(e: Event) {
      const { target } = e;
      const isClickedOnIgnoredElem = ignoredRefs?.find(ref => isContainTarget(ref, target));

      if (!isContainTarget(innerRef, target) && !isClickedOnIgnoredElem) {
        onOuterClick(e);
      }
    }
  }, [onOuterClick, innerRef]);
}
